"use strict";

var _classCallCheck = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/getPrototypeOf");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _SvgDefEntry = _interopRequireDefault(require("./SvgDefEntry"));
var _utils = require("./utils");
var _ZoomManager = _interopRequireDefault(require("../zoom/ZoomManager"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
// Copyright (c) 2019 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var STYLE = {
  left: 0,
  minHeight: '100%',
  minWidth: '100%',
  position: 'absolute',
  top: 0
};
var SvgLayer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SvgLayer, _React$PureComponent);
  var _super = _createSuper(SvgLayer);
  function SvgLayer() {
    _classCallCheck(this, SvgLayer);
    return _super.apply(this, arguments);
  }
  _createClass(SvgLayer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        classNamePart = _this$props.classNamePart,
        getClassName = _this$props.getClassName,
        defs = _this$props.defs,
        extraWrapper = _this$props.extraWrapper,
        graphState = _this$props.graphState,
        setOnContainer = _this$props.setOnContainer,
        standalone = _this$props.standalone,
        topLayer = _this$props.topLayer;
      var containerProps = (0, _utils.assignMergeCss)({
        className: getClassName(classNamePart)
      }, (0, _utils.getProps)(setOnContainer, graphState));
      var content = /*#__PURE__*/React.createElement("g", containerProps, defs && /*#__PURE__*/React.createElement("defs", null, defs.map(function (defEntry) {
        return /*#__PURE__*/React.createElement(_SvgDefEntry.default, Object.assign({
          key: defEntry.localId
        }, defEntry, {
          getClassName: getClassName,
          graphState: graphState
        }));
      })), children);
      if (extraWrapper) {
        content = /*#__PURE__*/React.createElement("g", extraWrapper, content);
      }
      if (!standalone && !topLayer) {
        return content;
      }
      var zoomTransform = graphState.zoomTransform;
      return /*#__PURE__*/React.createElement("svg", {
        className: getClassName('SvgLayer'),
        style: STYLE
      }, /*#__PURE__*/React.createElement("g", {
        className: getClassName('SvgLayer--transformer'),
        transform: _ZoomManager.default.getZoomAttr(zoomTransform)
      }, content));
    }
  }]);
  return SvgLayer;
}(React.PureComponent);
exports.default = SvgLayer;